export const INIT_ACTION = '@action/init';
export const INIT_ACTION_SUCCESS = '@action/initSuccess';